import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * AlertInfo Component - Variants & Status Options
 *
 * The AlertInfo component displays messages to the user with visual variants and statuses.
 *
 * Props:
 * - variant: Controls the style and placement of the accent/border.
 *    Allowed values:
 *      - 'left-accent'  (default)
 *      - 'top-accent'
 *      - 'outline'
 *      - 'subtle'
 *
 * Example Usage:
 * <AlertInfo variant="subtle" id="my.warning.msg" />
 *
 */
const AlertInfo = props => {
    const { id = 'common.no_text', skipIntl = false, textReplacements = {}, variant = 'left-accent' } = props;

    return (
        <div className={`usa-alert gi-alert gi-alert__${variant} gi-alert__info`}>
            <div className="gi-alert__body">
                <div className="gi-alert__text">
                    {skipIntl ? (
                        id
                    ) : (
                        <FormattedMessage
                            id={id}
                            values={{
                                ...textReplacements,
                                strong: function (chunks) {
                                    return <strong>{chunks}</strong>;
                                },
                                i: function (chunks) {
                                    return <i>{chunks}</i>;
                                },
                                p: function (chunks) {
                                    return <p>{chunks}</p>;
                                },
                                ul: function (chunks) {
                                    return <ul>{chunks}</ul>;
                                },
                                li: function (chunks) {
                                    return <li>{chunks}</li>;
                                },
                                br: <br />,
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AlertInfo;
